import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { amenityOption } from "Apis/amenity";

export const OccasionContext = createContext();

export const OccasionContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [amenityList, setAmenityList] = useState([]);

  const getAllAmenities = async () => {
    let response = await amenityOption();
    if (response?.status === 200) {
      const formatted = response.data.data.rows?.map((item) => ({
        id: parseInt(item?.id),
        label: item?.name,
      }));
      setAmenityList(formatted);
      return formatted; // ← return so form can use it immediately on mount
    }
    return [];
  };

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <OccasionContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        amenityList,
        getAllAmenities,
      }}
    >
      {children}
    </OccasionContext.Provider>
  );
};

OccasionContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OccasionContextProvider;
